import React, { useState } from "react";
import config from "../../../config/config.json";
import CustomModal from "../../CustomModal/CustomModal";
import CustomCloseIcon from "../../../assets/icons/CustomCloseIcon";
import { Accordion, AccordionDetails, AccordionSummary } from "@mui/material";
import CustomArrowIcon from "../../../assets/icons/CustomArrowIcon";
import { HelpModalProps } from "../../../type/CustomModal";

const HelpModal: React.FC<HelpModalProps> = ({
  openModal = false,
  setOpenModal,
}) => {
  const { accordionData } = config;
  const [expanded, setExpanded] = useState<boolean | number>(false);

  const handleChange =
    (panel: number) => (_event: React.SyntheticEvent, isExpanded: boolean) => {
      setExpanded(isExpanded ? panel : false);
    };

  return (
    <div>
      <CustomModal
        open={openModal}
        setOpen={setOpenModal}
        children={
          <div className="customModalContainerOuter">
            <div
              className="custom-container-header"
              style={{ borderRadius: "10px 10px 0px 0px" }}
            >
              <span className="text-white">Help</span>
              <div
                className="custom-icon-button"
                onClick={() => setOpenModal(false)}
              >
                <CustomCloseIcon />
              </div>
            </div>

            {/* HELP MODAL DATA */}
            <div className="helpOuter">
              {accordionData?.map((item, index) => (
                <div key={index} className="helpOuterInner">
                  <Accordion
                    expanded={expanded === index}
                    onChange={handleChange(index)}
                  >
                    <AccordionSummary
                      expandIcon={
                        <div className=" cursor-pointer bg-[#464f50] rounded-sm  w-[24px] h-[24px] grid items-center justify-center">
                          <CustomArrowIcon />
                        </div>
                      }
                      aria-controls="panel1-content"
                      id="panel1-header"
                    >
                      <h5> {item?.summary} </h5>
                    </AccordionSummary>
                    <AccordionDetails>
                      <h4> {item.details.question} </h4>
                      <div>
                        <div
                          dangerouslySetInnerHTML={{
                            __html: item.details.ans,
                          }}
                        />
                      </div>
                    </AccordionDetails>
                  </Accordion>
                </div>
              ))}
            </div>
          </div>
        }
      />
    </div>
  );
};

export default HelpModal;
